export default __webpack_public_path__ + "static/media/noun_locked lock_1010538.e13ce951.svg";